export const TYPE_COLORS = {
  bug: '#ef4444',
  task: '#3b82f6',
  story: '#22c55e',
  epic: '#a855f7',
  feature: '#f59e0b',
  requirement: '#06b6d4',
};

export const STATUS_COLORS = {
  not_started: '#9ca3af',
  in_progress: '#3b82f6',
  verification: '#f59e0b',
  done: '#10b981',
};

export const LOCATION_COLORS = {
  board: '#3b82f6',
  backlog: '#9ca3af',
};
